import _ from 'lodash'
import * as query from '@/queries/siteRole'
import utils from '@/store/utils'
import common from '@/utils/common'
import store from '@/store'

const defaultState = function () {
  return {
    mode: 0,
    tableSetList: [{}],
    tdLists: [],
    totalCount: 0,
    listIndex: -1,
    currentPage: 0,
    size: 10,
    siteRoleOptions: [],
    isAndSearch: false,
    searchKeyword: '',
    searchKey: 'site_list',
    searchConditions: {}
  }
}

export default {
  namespaced: true,
  state: defaultState(),
  mutations: {
    update (state, data) {
      const rowData = utils.pick(data, utils.createKeys(query.GRAPH_QL_QUERY_SITE_ROLE_LIST, 1))
      _.forEach(state.tdLists, (val, index) => {
        if (val.uuid === data.uuid) {
          _.merge(state.tdLists[index], _.cloneDeep(rowData))
        }
      })
    },
    delete (state, uuid) {
      _.remove(state.tdLists, (val) => val.uuid === uuid)
    }
  },
  getSiteRoleOptions: async function (reGet = false) {
    if (store.state.SiteRole.siteRoleOptions.length === 0 || reGet) {
      const execQuery = common.addGraphQlCondition(query.GRAPH_QL_QUERY_SITE_ROLE_LIST, { keyword: '' })
      const result = await common.postGraphQl(execQuery)
      Object.keys(result.data.data.siteRoles).forEach((key) => {
        result.data.data.siteRoles[key].code = result.data.data.siteRoles[key].uuid
      })
      store.dispatch({
        type: 'set',
        states: {
          'SiteRole/siteRoleOptions': result.data.data.siteRoles
        }
      })
    }
  },
  getDefaultState: defaultState
}
